import { readCookie } from './Cookie';

export function signInCheck(getUserId = false) {
  let user;
  let signedIn;
  try {
    user = readCookie('un');
    signedIn = readCookie('U');
  } catch (error) {
    console.log(`Failed to read cookie : ${error}`);
  }
  let username = '';
  if (signedIn && signedIn !== 'anonymous') {
    // sI not being able to read. but can read un?
    // username = this.props.userName; //store is getting empty
    username = getUserId ? decodeURIComponent(signedIn) : decodeURIComponent(user); // store is getting empty so reading from cookie - think of alt
  }
  return username;
}

export function getScreenName() {
  let user;
  try {
    user = readCookie('SN');
    if (!user) {
      user = readCookie('un');
    }
  } catch (error) {
    console.log(`Failed to read cookie : ${error}`);
  }
  let username = '';
  username = decodeURIComponent(user); // store is getting empty so reading from cookie - think of alt
  return username;
}

export function getFullName() {
  let user;
  try {
    user = readCookie('un');
  } catch (error) {
    console.log(`Failed to read cookie : ${error}`);
  }
  let username = '';
  username = decodeURIComponent(user); // store is getting empty so reading from cookie - think of alt
  return username;
}

export function checkLoginAndRedirect() {
  if(!signInCheck().length) {
    window.location.href = `/login?referrer=${window.location.pathname}`;
    return true
  }
  return false
}